import React from 'react';
import DocumentWrapper from '../common/DocumentWrapper';
import { withTranslation } from '../../../hoc';
import routes, { redirects } from './routes';
import { MyDataDashboardTemplate } from '../common/MyDataDashboardTemplate';

const Education = (props) => (
  <DocumentWrapper formTitle="Education" {...props}>
    <MyDataDashboardTemplate
      {...props}
      showSideBar
      routes={routes}
      redirects={redirects}
      render={(renderPropsData) => (
        <MyDataDashboardTemplate.Main {...renderPropsData} card={false} />
      )}
    />
  </DocumentWrapper>
);

export default withTranslation(Education);
